__turbopack_context__.v({
  "Description": "GridSection-module-scss-module__eq91Rq__Description",
  "Inner": "GridSection-module-scss-module__eq91Rq__Inner",
  "VerticalCenter": "GridSection-module-scss-module__eq91Rq__VerticalCenter",
});
